import React from "react";
import { Routes, Route } from "react-router-dom";
import LoginPage from "../pages/Login"; // Import page components
import Dashboard from "../pages/Dashboard"
import DashboardSummary from "../views/Summary";
import DocumentProcessView from "../views/DocProcessView";
import ArchiveSummary from "../views/Archive";
import CaseDetail from "../views/CaseDetail";
import UserProfile from "../views/Profile";
import ShipmentRegistrationView from "../views/ShipmentRegistrationView";
import CCIViewer from "../views/ClearanceInstruct";

function AppRoutes() {
  return (
    <Routes>
      <Route path="/" element={<LoginPage />} />
      <Route path="/dashboard" element={<Dashboard />}>
        <Route index element={<DashboardSummary />} />
        <Route path = "cases/:shipmentId" element={<CaseDetail />}  />
        <Route path = "register/:threadId/:documentId" element={<ShipmentRegistrationView />}  />
        <Route path = "instruction/:threadId/:documentId" element={<CCIViewer />}  />
        <Route path= "process/:threadId/:documentId" element={<DocumentProcessView />} />
      </Route>
      <Route path="/archived" element={<Dashboard />}>
        <Route index element={<ArchiveSummary />} />
        <Route path = "cases/:shipmentId" element={<CaseDetail />}  />
        <Route path= "process/:threadId/:documentId" element={<DocumentProcessView />} />
      </Route>
      <Route path="/profile" element={<Dashboard />}>
        <Route index element={<UserProfile />} />
      </Route>

    </Routes>
  );
}

export default AppRoutes;